import { render, staticRenderFns } from "./photoswipe-gallery.vue?vue&type=template&id=274a3b08&"
import script from "./photoswipe-gallery.vue?vue&type=script&lang=js&"
export * from "./photoswipe-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports